<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
              首页
            </router-link>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              <span class="font-semibold text-psychology-primary">{{ assessmentType === 'self' ? '给自己测' : '为恋人测' }}</span>
            </div>
          </div>
          <button @click="goBack" class="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            返回
          </button>
          <button @click="goBack" class="sm:hidden inline-flex items-center justify-center p-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
          </button>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-4xl mx-auto space-y-6">
        <!-- 页面标题 -->
        <div class="text-center">
          <h1 class="text-3xl font-bold text-psychology-primary mb-2">恋爱占有欲指数评估</h1>
          <p class="text-gray-600 text-lg">基于心理学研究的专业测评工具</p>
        </div>

        <!-- 未完成会话检测 -->
        <IncompleteSessionDialog
          v-if="showIncompleteDialog"
          :show="showIncompleteDialog"
          :progress-info="incompleteSessionInfo"
          @continue="handleContinueSession"
          @restart="handleRestartSession"
        />

        <!-- 知情同意书 -->
        <ConsentForm 
          v-if="!showIncompleteDialog" 
          :assessmentType="assessmentType"
        />

        <!-- 底部说明 -->
        <div class="text-center text-xs text-gray-500">
          <p>本工具基于心理学研究开发，参考依恋理论、浪漫嫉妒研究、共依赖理论等经典理论，采用标准化的李克特量表和频率量表进行测量。</p>
        </div>
      </div>
    </main>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script>
import ConsentForm from '../components/assessment/ConsentForm.vue'
import IncompleteSessionDialog from '../components/assessment/IncompleteSessionDialog.vue'
import BackToTop from '../components/BackToTop.vue'
import { 
  getIncompleteSessionByType, 
  getSessionProgressInfo, 
  clearSessionProgress
} from '../utils/sessionStorage.js'

export default {
  name: 'StartAssessmentPage',
  components: {
    ConsentForm,
    IncompleteSessionDialog,
    BackToTop
  },
  data() {
    return {
      assessmentType: 'self', // 'self' 或 'partner'
      showIncompleteDialog: false,
      incompleteSessionInfo: null
    }
  },
  created() {
    // 从路由参数获取测评类型
    this.assessmentType = this.$route.query.type || 'self'
    this.checkIncompleteSession()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    checkIncompleteSession() {
      // 检查是否有未完成的会话
      const incompleteSession = getIncompleteSessionByType(this.assessmentType)
      if (incompleteSession) {
        this.incompleteSessionInfo = getSessionProgressInfo(incompleteSession.id)
        this.showIncompleteDialog = true
        console.log('Found incomplete session:', this.incompleteSessionInfo)
      }
    },
    handleContinueSession() {
      // 继续未完成的会话
      const incompleteSession = getIncompleteSessionByType(this.assessmentType)
      if (incompleteSession) {
        this.$router.push({
          path: '/assessment/questions',
          query: { 
            type: this.assessmentType,
            sessionId: incompleteSession.id
          }
        })
      }
    },
    handleRestartSession() {
      // 重新开始，清除未完成会话
      const incompleteSession = getIncompleteSessionByType(this.assessmentType)
      if (incompleteSession) {
        // 删除未完成的会话
        const { deleteSession } = require('../utils/sessionStorage.js')
        deleteSession(incompleteSession.id)
      }
      
      // 清除进度数据
      clearSessionProgress()
      
      // 清除本地旧答案与相关残留，防止题库页恢复旧答题
      try {
        const typeKey = `rpi_answers_${this.assessmentType}`
        localStorage.removeItem(typeKey) // 按类型存储的新键
        localStorage.removeItem('rpi_answers') // 旧统一键（兼容）
        localStorage.removeItem('rpi_basic_info') // 基本信息（避免自动带入）
        localStorage.removeItem('rpi_submission_time') // 旧提交时间（兼容）
      } catch (e) {
        console.error('Failed to clear local draft data on restart:', e)
      }
      
      // 隐藏对话框，显示同意书
      this.showIncompleteDialog = false
      this.incompleteSessionInfo = null
    }
  }
}
</script>

